// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__1plCE","navwrapper":"NavBar_navwrapper__2Yx-T","title":"NavBar_title__3us5d","listwrapper":"NavBar_listwrapper__K2Quv"};